module.exports = __webpack_public_path__ + "static/img/vload.3f79aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/funding/vload.png
// module id = 574
// module chunks = 0